import { RouteObject } from "react-router-dom";
import { Module } from "../../assets/types/common";
import RequireAuth from "../../auth/requireAuth";
import { LookupCategoryDto } from "../../services/dto/system/lookupCategoryDto";
import { LookupDto } from "../../services/dto/system/lookupDto";
import { LookupGroupDto } from "../../services/dto/system/lookupGroupDto";
import { LookupGroupContainer } from "../lookup/lookupgroup/lookupGroupContainer";
import { LookupTypeContainer } from "../lookup/lookuptype/lookupTypeContainer";
import { LookupValueContainer } from "../lookup/lookupvalue/lookupValueContainer";
import { CountyContainer } from "./county/countyContainer";
import { StateContainer } from "./state/stateContainer";
import { SettingContainer } from "../setting/settingContainer";
import { SettingDto } from "../../services/dto/system/settingDto";
import { permissions } from "../../assets/configuration/claimSettings";

export const SystemRoutes: RouteObject = {
  path: "system",
  children: [
    {
      path: "county",
      element: (
        <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
          <CountyContainer />
        </RequireAuth>
      ),
    },
    {
      path: "states",
      element: (
        <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
          <StateContainer />
        </RequireAuth>
      ),
    },
    {
      path: "lookuptype",
      element: (
        <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
          <LookupTypeContainer<LookupCategoryDto> moduleType={Module.System} />
        </RequireAuth>
      ),
    },
    {
      path: "lookupgroup",
      element: (
        <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
          <LookupGroupContainer<LookupGroupDto> moduleType={Module.System} />
        </RequireAuth>
      ),
    },
    {
      path: "lookupvalue",
      element: (
        <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
          <LookupValueContainer<LookupDto> moduleType={Module.System} />
        </RequireAuth>
      ),
    },
    {
      path: "settings",
      element: (
        <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
          <SettingContainer<SettingDto> moduleType={Module.System} />
        </RequireAuth>
      ),
    },
  ],
};
